import { Tooltip, TooltipProps } from '@mui/material'
import { withStyles } from '@mui/styles'
import { ReactElement, ReactNode } from 'react'

interface GroupcalTooltipProps {
  children: ReactElement | ReactNode
  title: ReactNode
  delay?: number
  color?: string
  enterDelay?: number
  placement?: string
  backgroundColor?: string
  textColor?: string
  textSize?: string
  enterNextDelay?: number
}

export default function GroupcalTooltip(props: GroupcalTooltipProps) {
  return (
    <Tooltip
      leaveDelay={200}
      enterDelay={props.enterDelay ?? 700}
      enterNextDelay={props.enterNextDelay ?? 1000}
      placement={props.placement ?? 'bottom'}
      title={props.title}
      PopperProps={{ style: { zIndex: 9999 } }}
      componentsProps={{
        tooltip: {
          style: {
            lineHeight: '22px',
            letterSpacing: '0.5px',
            backgroundColor:
              props.backgroundColor || 'default-background-color',
            color: props.textColor || 'default-text-color',
            fontSize: props.textSize || 'default-text-size',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)', // Add this line
            borderRadius: '4px' // Add this line to make the tooltip rounded
          }
        }
      }}
    >
      <div>{props.children}</div>
    </Tooltip>
  )
}
